import { useMemo } from 'react';
import { buildSensorDrawerBooleanCollapsibleGroups, buildSensorDrawerMetricCollapsibleGroups } from '../../../../utils/electronicsDashboardUtils';
import { MetricCollapsibleDrawerSection, type SensorDrawerSectionProps } from '../DrawerDraggableLayout';

export type SensorTypeDrawerSectionProps = SensorDrawerSectionProps & {
  sensorClassName: string;
};

const SensorTypeDrawerSection = ({ sensorPorts, projectCode, sensorClassName }: SensorTypeDrawerSectionProps) => {
  const metricGroups = useMemo(
    () => buildSensorDrawerMetricCollapsibleGroups(sensorPorts, projectCode, sensorClassName),
    [sensorPorts, projectCode, sensorClassName]
  );

  const booleanGroups = useMemo(
    () => buildSensorDrawerBooleanCollapsibleGroups(sensorPorts, projectCode, sensorClassName),
    [sensorPorts, projectCode, sensorClassName]
  );

  return (
    <>
      <MetricCollapsibleDrawerSection groups={metricGroups} />
      <MetricCollapsibleDrawerSection groups={booleanGroups} />
    </>
  );
};

export default SensorTypeDrawerSection;
